import type { FC, PropsWithChildren } from 'react'

import { config } from '@skytech/config'
import { Button } from '@skytech/ui/Button'
import { ExternalLink } from '@skytech/ui/ExternalLink'
import { useDispatch, useSelector } from 'react-redux'

import { hideInitialSplash, showInitialSplashMngr } from '@/ducks/onboarding/onboardingActions'
import { displayInitialSplashMngr } from '@/ducks/onboarding/onboardingSelectors'
import { openTab } from '@/util/misc'

import { Translation } from '../i18n/Translation'

import './initial-splash.scss'

const RedText: FC<PropsWithChildren> = ({ children }) => (
  <span style={{ color: '#e74c3c' }}>{children}</span>
)

const InitialSplash = () => {
  const dispatch = useDispatch()
  const displayMngr = useSelector(displayInitialSplashMngr)

  if (displayMngr) {
    return <InitialSplashMngr />
  }

  return (
    <div className="content pc-order__initial-splash">
      <h1>
        <Translation id="Bestilling av PC og Tilbehør" />
      </h1>

      <h2 style={{ textAlign: 'left', fontSize: '1rem' }}>LEDERE</h2>

      <p>
        Som leder har du mulighet til å bestille PC og tilbehør på vegne av en ansatt i din egen{' '}
        <RedText>seksjon/avdeling</RedText>. Når f.eks nye ansatte begynner i din{' '}
        <RedText>seksjon/avdeling</RedText> er det viktig at PC og alt av relevant tilbehør er
        bestilt og levert før den ansatte starter første arbeidsdag.
        <br />
        Merk at det kan ta <RedText>seksjon/avdeling</RedText> 1 uke fra bestilling til levering
        finner sted.
      </p>

      <h2 style={{ textAlign: 'left', fontSize: '1rem' }}>NB!</h2>

      <p>
        <RedText>
          Man kan bare bestille PC og utstyr til fast ansatte. Utstyr til sommervikarer,
          midlertidige ansatte og vikarer må bestilles hos{' '}
          <ExternalLink href="helpdesk@multiconsult.no">helpdesk@multiconsult.no</ExternalLink>
        </RedText>
        <br />
        Hvis du bestiller på vegne av en ansatt, må vedkommende du bestiller til, allerede være lagt
        opp i HR systemet (Maconomy) for at bestilling i denne portalen skal fungere. Den ansatte må
        også ha et registrert brukernavn i samme system. Hvis dette ikke er registrert vil
        vedkommende IKKE være søkbar i listen over ansatte du kan velge blant ved bestilling.
        <br />
        Ta i så fall kontakt med HR avdelingen slik at de får registrert navn, telefon og brukernavn
        på den ansatte. Merk at det da vil ta ca 1 døgn fra registrering, til du kan bestille på
        vegne av den ansatte.
        <br />
        Kontakt HR på:{' '}
        <ExternalLink href="mailto:hr-avdeling@multiconsult.no">
          hr-avdeling@multiconsult.no
        </ExternalLink>
      </p>

      <h2>Hva ønsker du?</h2>

      <div className="options">
        <div>
          <h3>
            <Translation id="Ansatt" />
          </h3>

          <p>
            <Translation id="Bestill PC og tilbehør" />
          </p>
          <Button variant="primary" onClick={() => dispatch(hideInitialSplash())}>
            <Translation id="Neste" />
          </Button>
        </div>

        <div>
          <h3>
            <Translation id="Leder" />
          </h3>

          <p>
            <Translation id="Bestill PC og tilbehør på vegne av en ansatt" />
          </p>

          <Button variant="primary" onClick={() => dispatch(showInitialSplashMngr())}>
            <Translation id="Neste" />
          </Button>
        </div>
      </div>
    </div>
  )
}

const InitialSplashMngr = () => {
  const dispatch = useDispatch()
  const openManager = () => {
    openTab(config.MANAGER_URL)
  }

  return (
    <div className="content pc-order__initial-splash">
      <h1>
        <Translation id="Bestilling av PC og Tilbehør" />
      </h1>

      <h3>
        <Translation id="LEDERE" />
      </h3>

      <p>
        <Translation id="Som leder har du mulighet" />
      </p>

      <p>
        <Translation id="Merk at det kan ta opp til 1 uke fra bestilling til levering finner sted" />
      </p>

      <h2>
        <Translation id="Hva ønsker du?" />
      </h2>

      <div className="options">
        <div>
          <h3>
            <Translation id="Bestill PC og tilbehør" />
          </h3>

          <Button variant="primary" onClick={() => dispatch(hideInitialSplash())}>
            <Translation id="Neste" />
          </Button>
        </div>

        <div>
          <h3>
            <Translation id="Bestill PC og tilbehør på vegne av en ansatt" />
          </h3>

          <Button variant="primary" onClick={() => openManager()}>
            <Translation id="Neste" />
          </Button>
        </div>
      </div>

      <p>
        <b>
          <Translation id="NB!" />
        </b>
        <br />
        <Translation id="Hvis du bestiller på vegne av en ansatt" />
      </p>

      <p>
        <Translation id="Ta i så fall kontakt med HR" />
      </p>

      <p>
        <Translation id="Kontakt HR på" />
      </p>
    </div>
  )
}

export default InitialSplash
